import React from 'react'
import { URL_LOG_STADOS } from '../../router/Url';

export const AddLog = ({id_code,status_old,status_new,notes,user,planta,action,timestamp, pagina, n_pp}) => {
    return new Promise(async (resolve, reject) => {
        let query = await fetch(URL_LOG_STADOS,{
          method: 'POST',
          headers: {
            'authorization': "marcuxo",
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({id_code,status_old,status_new,notes,user,planta,action,timestamp, pagina, n_pp})
        })
        let responsito = await query.json();
        // console.log(responsito);
        if(responsito){
          resolve(responsito)
        }else{
          resolve(responsito)
        }
    })
}
